import { render, staticRenderFns } from "./emailSettingsColumn.vue?vue&type=template&id=b9e10fba&scoped=true&"
import script from "./emailSettingsColumn.vue?vue&type=script&lang=js&"
export * from "./emailSettingsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e10fba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
